export default {"src":"/_next/static/media/star-gold.73536cc1.svg","height":10,"width":11};